const captureWritingAssistantDocument = editor => {
  const { textBeforeCaret, textAfterCaret } = editor.getTextSurroundingCaret()
  return { textBeforeCaret, textAfterCaret }
}

export { captureWritingAssistantDocument }
